import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { OrderSuccess, OrderCancel } from "./OrderResult";

const pathname = window.location.pathname;
let RootEl;
if (pathname === "/success") {
  RootEl = (
    <OrderSuccess onClearCart={() => { try { localStorage.removeItem("tsbbq_cart"); } catch {} }} />
  );
} else if (pathname === "/cancel") {
  RootEl = <OrderCancel />;
} else {
  RootEl = <App />;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {RootEl}
  </React.StrictMode>,
);
